<template>
  <div
    class="min-h-screen gig-upcrate-app flex-1 mt-1 bg-gray-100 px-4 pt-12 shadow-lg items-center"
  >
    <div class="bg-white w-fullrounded-lg shadow">
      <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-2">
        <div class="flex">
          <button
            :class="$colors.primary"
            class="rounded-full flex justify-center items-center w-8 h-8 mr-3"
            @click="RouterBack()"
          >
            <i class="material-icons">chevron_left</i>
          </button>
          <div v-if="!formData._id" class="text-2xl font-bold text-blue-500">
            New role
          </div>
          <div v-else class="text-2xl font-bold text-blue-500">Edit role</div>
        </div>
      </div>

      <div class="">
        <div class="bg-white rounded-lg p-6 pt-2">
          <div class="grid lg:grid-cols-2 gap-6">
            <div
              class="border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
            >
              <div
                class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
              >
                <p>
                  <label for="name" class="bg-white text-gray-700 px-1"
                    >Name <span :class="$colors.required">*</span>
                  </label>
                </p>
              </div>
              <p>
                <input
                  id="name"
                  autocomplete="false"
                  tabindex="0"
                  type="text"
                  v-model="formData.name"
                  class="py-2 text-xs px-2 outline-none block h-full w-full"
                />
              </p>
            </div>

            <div
              class="border h-10 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
            >
              <div
                class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
              >
                <p>
                  <label for="name" class="bg-white text-gray-700 px-1"
                    >Type *</label
                  >
                </p>
              </div>
              <p>
                <select
                  id="type"
                  name="type"
                  autocomplete="type"
                  v-model="formData.type"
                  class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white"
                >
                  <option selected disabled :value="null">Type</option>
                  <option v-for="type in types" :key="type" :value="type">
                    {{ type }}
                  </option>
                </select>
              </p>
            </div>

            <div class="border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
            >
              <div
                class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
              >
                <p>
                  <label for="description" class="bg-white text-gray-700 px-1"
                    >Description
                  </label>
                </p>
              </div>
              <p>
                <input
                  id="description"
                  autocomplete="false"
                  tabindex="0"
                  type="text"
                  v-model="formData.description"
                  class="py-2 text-xs px-2 outline-none block h-full w-full"
                />
              </p>
            </div>
          </div>

          <div
            class="border hover:border-blue-400 mt-4 px-4 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
          >
            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
              <p>
                <label for="description" class="bg-white text-gray-700 px-1"
                  >Permissions <span :class="$colors.required">*</span></label
                >
              </p>
            </div>
            <div class="">
              <div class="w-full mt-2">
                <table class="table w-full text-center">
                  <thead class="bg-gray-100 text-black">
                    <tr>
                      <th
                        class="px-5 py-2 border-gray-200 text-left text-xs font-semibold text-gray-700 capitalize tracking-wider"
                      >
                        Model
                      </th>
                      <th
                        class="px-5 py-2 border-gray-200 text-left text-xs font-semibold text-gray-700 capitalize tracking-wider"
                      >
                        Create
                      </th>
                      <th
                        class="px-5 py-2 border-gray-200 text-left text-xs font-semibold text-gray-700 capitalize tracking-wider"
                      >
                        Read
                      </th>
                      <th
                        class="px-5 py-2 border-gray-200 text-left text-xs font-semibold text-gray-700 capitalize tracking-wider"
                      >
                        Update
                      </th>
                      <th
                        class="px-5 py-2 border-gray-200 text-left text-xs font-semibold text-gray-700 capitalize tracking-wider"
                      >
                        Delete
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(el, index) in modules"
                      :key="index"
                      :class="index % 2 == 0 ? 'bg-gray-100' : ''"
                    >
                      <td
                        class="px-5 py-2 pt-3 text-left border-gray-200 bg-white text-sm"
                      >
                        <p class="text-gray-700 capitalize">
                          {{ el.model }}
                        </p>
                      </td>
                      <td
                        class="px-5 py-2 pt-3 text-left border-gray-200 bg-white text-sm"
                      >
                        <p class="text-gray-600 ml-3 text-semibold capitalize">
                          <label
                            class="inline-flex text-sm items-center capitalize"
                          >
                            <input
                              v-model="el.access.create"
                              type="checkbox"
                              class="form-checkbox border-gray-500 h-4 w-4 text-blue-500"
                            />
                          </label>
                        </p>
                      </td>
                      <td
                        class="px-5 py-2 pt-3 text-left border-gray-200 bg-white text-sm"
                      >
                        <p class="text-gray-600 ml-2 text-semibold capitalize">
                          <label
                            class="inline-flex text-sm items-center capitalize"
                          >
                            <input
                              v-model="el.access.read"
                              type="checkbox"
                              class="form-checkbox border-gray-500 h-4 w-4 text-blue-500"
                            />
                          </label>
                        </p>
                      </td>
                      <td
                        class="px-5 py-2 pt-3 text-left border-gray-200 bg-white text-sm"
                      >
                        <p class="text-gray-600 ml-3 text-semibold capitalize">
                          <label
                            class="inline-flex text-sm items-center capitalize"
                          >
                            <input
                              v-model="el.access.update"
                              type="checkbox"
                              class="form-checkbox border-gray-500 h-4 w-4 text-blue-500"
                            />
                          </label>
                        </p>
                      </td>
                      <td
                        class="px-5 py-2 pt-3 text-left border-gray-200 bg-white text-sm"
                      >
                        <p class="text-gray-600 ml-3 text-semibold capitalize">
                          <label
                            class="inline-flex text-sm items-center capitalize"
                          >
                            <input
                              v-model="el.access.delete"
                              type="checkbox"
                              class="form-checkbox border-gray-500 h-4 w-4 text-blue-500"
                            />
                          </label>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        <hr class="mt-6 border-b-1 border-gray-400">
        <h6 class="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">Access pages user</h6>
          <div class="flex flex-wrap gig-search-tags-group">
          <div  class="w-5/6 px-4">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="grid-password">Pages </label>
                <v-select v-model="formData.access_pages"  :options="access_pages" multiple class="px-3 border access_pages py-2 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150">    
                </v-select>
            </div>
          </div>
           <section class="generic-section-education box-shadow-z4 v6zYET0 positive-keywords-education">
              <div class="hover-bridge"></div>
              <header><h6>Words explanation</h6></header>
              <div class="subtitle">
                  <ul class="tbody-7 co-text-medium p-l-16 p-r-8">
                      <li><b>Home</b> : home page</li>
                      <li><b>errorPage</b>: Error page</li>
                      <li><b>profile</b>: Profile page</li>
                      <li><b>newUser</b>: Create user page</li>
                      <li><b>updateUser</b>: Update user page</li>
                      <li><b>viewProduct</b>: View details product page</li>
                      <li><b>confirmation</b>: Callcenter confirmation page</li>
                      <li><b>callcenter</b>: Analytics page</li>
                      <li><b>viewanalytics</b>: view user analytics details</li>
                      <li><b>viewanAlytics</b>: view user analytics order details</li>
                  </ul>
              </div>
          </section>
         </div>
          <div class="mt-6 pt-3 flex justify-center">
            <button
              class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-blue-500 hover:shadow-inner hover:bg-blue-700 transition-all duration-300"
              @click="save"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formData: {},
      modules: [],
      types: [
        "Seller",
        "TeleConsultant",
        "StockManager",
        "Courier",
        "Accountant",
        "Admin",
        "Administrateur",
        "CallenterManager",
        "NRP",
        "Subscription",
        'AccountManager'
      ],
       access_pages:['Home','createStore','errorPage','profile','users','newUser','updateUser','roles','newRole','updateRole','teams','newTeam','updateTeam','senders','products','newProduct','updateProduct','viewProduct','warehouses','newWarehouse','updateWarehouse',
      'regroupements','newRegroupement','updateRegroupement','categories','newCategory','updateCategory','viewCategory','orders','newOrder','updateOrder','viewOrder','importOrders','confirmation','expeditions','newExpedition','updateExpedition','viewExpedition',
      'sourcings','newSourcing','updateSourcing','viewSourcings','status','newStatus','updateStatus','viewStatus','zones','newZones','updateZones','shippings','updateShippings','viewShipping','subscribers','newSubscribers','updateSubscribers','viewSubscribers','callcenter','viewanalytics','viewAnalytics',
      'payments','multiWarehouses','newPayments','viewpayment','refunds','newRefunds','viewRefund','settings','avoirs','newAvoir','updateAvoir','apiOrders','tickets','newTicket', 'updateTicket', 'viewTicket'],
    };
  },

  async mounted() {
    this.dataToEdit();
    this.setModules();
  },
  methods: {
     RouterBack: function() {
       this.$router.back();
    },
    async save() {
      this.formData.permissions = this.modules;

      if (this.formData._id) {
        const data = await this.$server.update("roles", this.formData);
        if (data && data._id) alert("role updated", "success");
        else alert(data, "warning");
      } else {
        if (this.checkData()) {
          const data = await this.$server.create("roles", this.formData);
          if (data && data._id) {
            alert("role created", "success");
            //console.log(data);
            this.formData = {};
            this.setModules();
          }else alert(data, "warning");
        } else alert(`you must fill all the fields !! `, "warning");
      }
    },
    checkData() {
      if (this.formData.name) {
        return true;
      } else {
        return false;
      }
    },

    setModules() {
      this.modules = [
        {
          model: "warehouses",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "categories",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "expeditions",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "orders",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "payments",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "paymentorders",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "paymentsHistories",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "products",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "roles",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "shippings",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "status",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "statusHistories",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "stockHistories",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "shippingsHistories",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "subscribers",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "users",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "zones",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "teams",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "settings",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "analytics",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "senders",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "refunds",
          access: { create: false, read: false, update: false, delete: false },
        },
         {
          model: "sourcings",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "refundsHistories",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "sourcingsHistories",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "regroupements",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "userSessions",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "dashboard",
          access: { create: false, read: false, update: false, delete: false },
        },
        {
          model: "tickets",
          access: { create: false, read: false, update: false, delete: false },
        },
      ];
    },
    async dataToEdit() {
      if (this.$route.params.id) {
        const editData = await this.$server.get("roles", {id: this.$route.params.id,});
        this.formData = editData.content;
        if(!this.formData.access_pages || (this.formData.access_pages && this.formData.access_pages.length==0)) this.formData.access_pages=this.access_pages;
        this.modules = this.formData.permissions;
        this.AddelementArray( {model: "warehouses",access: { create: false, read: false, update: false, delete: false }},this.modules);
        this.AddelementArray( {model: "senders",access: { create: false, read: false, update: false, delete: false }},this.modules);
        this.AddelementArray( {model: "refunds",access: { create: false, read: false, update: false, delete: false }},this.modules);
        this.AddelementArray( {model: "sourcings",access: { create: false, read: false, update: false, delete: false }},this.modules);
        this.AddelementArray( {model: "refundsHistories",access: { create: false, read: false, update: false, delete: false }},this.modules);
        this.AddelementArray( {model: "sourcingsHistories",access: { create: false, read: false, update: false, delete: false }},this.modules);
        this.AddelementArray( {model: "paymentorders",access: { create: false, read: false, update: false, delete: false }},this.modules);
        this.AddelementArray( {model: "paymentsHistories",access: { create: false, read: false, update: false, delete: false }},this.modules);
        this.AddelementArray( {model: "regroupements",access: { create: false, read: false, update: false, delete: false }},this.modules);
        this.AddelementArray( {model: "avoirs",access: { create: false, read: false, update: false, delete: false }},this.modules);
        this.AddelementArray( {model: "userSessions",access: { create: false, read: false, update: false, delete: false }},this.modules);
        this.AddelementArray( {model: "dashboard",access: { create: false, read: false, update: false, delete: false }},this.modules);
        this.AddelementArray( {model: "tickets",access: { create: false, read: false, update: false, delete: false }},this.modules);
        //console.log(this.formData);
      }else this.formData.access_pages=this.access_pages;
    },
     AddelementArray(element,array){
        Array.prototype.inArray = function(comparer) { 
          for(var i=0; i < this.length; i++) { 
              if(comparer(this[i])) return true; 
          }
          return false; 
        }; 

        // adds an element to the array if it does not already exist using a comparer 
        // function
        Array.prototype.pushIfNotExist = function(element, comparer) { 
            if (!this.inArray(comparer)) {
                this.push(element);
            }
        }; 
        array.pushIfNotExist(element, function(e) { 
            return e.model === element.model; 
        });
    },
  },
};
</script>
<style scoped>
.icon::after {
  content: "";
  display: block;
  position: absolute;
  border-top: 23px solid transparent;
  border-bottom: 17px solid transparent;
  border-left: 12px solid #3182ce;
  left: 100%;
  top: 0;
}
.gig-upcrate-app .gig-search-tags-group:hover .positive-keywords-education, .gig-upcrate-app .gig-search-tags-group:hover .search-tags-education {
  display: initial;
}
.gig-upcrate-app .gig-search-tags-group .positive-keywords-education {
  bottom: 100px;
}
.v6zYET0 {
  display: none;
  right: 0;
}
.gig-upcrate-app .generic-section-education {
  width: 12%;
  background: #fff;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid #dadbdd;
  min-height: 285px;
  padding: 16px 24px 24px;
  position: absolute;
  right: 70px;
  z-index: 10; 
}
.box-shadow-z4 {
  box-shadow: 0 .266px 1.13052px rgba(0,0,0,.06866),0 .89345px 3.79717px rgba(0,0,0,.10134),0 5px 17px rgba(0,0,0,.17);
}
.gig-upcrate-app .gig-search-tags-group .positive-keywords-education::before {
  top: 90px;
}
.gig-upcrate-app .generic-section-education::before {
  content: "";
  background: transparent url(https://fiverr-res.cloudinary.com/npm-assets/@fiverr/gig_management_perseus/apps/chip.88e56cb.svg) no-repeat 0 0;
  position: absolute;
  z-index: 1;
  display: block;
  overflow: hidden;
  width: 10px;
  height: 23px;
  top: 47px;
  left: -9px;
}
.gig-upcrate-app .gig-search-tags-group .positive-keywords-education .hover-bridge {
  margin-top: 270px;
}
.gig-upcrate-app .generic-section-education .hover-bridge {
  display: block;
  width: 130px;
  height: 130px;
  position: absolute;
  left: 60px;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
  z-index: -1;
}
.v6zYET0 ul {
  list-style-type: disc;
}
.p-l-16 {
  padding-left: 16px;
}
.p-r-8 {
  padding-right: 8px;
}
.text-body-3, .tbody-7 {
  font-size: 12px;
  line-height: 20px;
}
.co-text-medium {
  color: #7a7d85;
}

.gig-upcrate-app .generic-section-education .subtitle {
  font-size: 12px;
  line-height: 16px;
}
.text-body-3, .tbody-7 {
  font-size: 12px;
  line-height: 20px;
}
.co-text-medium {
  color: #7a7d85;
}
.gig-upcrate-app .generic-section-education > header {
  margin-bottom: 8px;
  display: block;
}
</style>
